/**
 * how a column on an annual report reduces a bucket of values to a single cell
 *
 * picked per column at create time (defaulted from the metric's aggregation flags) and adjustable later
 * non-annual reports leave this null
 */
export enum ColumnAggregation {
  SUM = "SUM",
  ARITHMETIC_MEAN = "ARITHMETIC_MEAN",
  GEOMETRIC_MEAN = "GEOMETRIC_MEAN",
  MIN = "MIN",
  MAX = "MAX",
  COUNT = "COUNT",
}
